<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
            <b-breadcrumb-item active>Profile</b-breadcrumb-item>
        </b-breadcrumb>
        <h1 class="page-title">User - <span class="fw-semi-bold">Profile</span>
        </h1>
        <b-row>


            <b-col lg="6" xs="6">
                <Widget customHeader>
                    <b-form-group>
                        <b-form @submit.prevent="saveProfile">


                            <legend><strong>Edit</strong> Profile</legend>

                            <b-form-group
                                    horizontal
                                    label="Full Name"
                                    label-for="normal-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <b-form-input type="text" v-model="profile.fullName" placeholder=""/>
                            </b-form-group>
                            <b-form-group
                                    horizontal
                                    label-for="title-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <div slot="label">
                                    Job Title
                                    <span class="help-block">Give us an idea on what you work</span>
                                </div>
                                <b-form-input type="text" id="title-field" v-model="profile.jobTitle" placeholder=""/>
                            </b-form-group>
                            <b-form-group
                                    horizontal
                                    label="City"
                                    label-for="city-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <b-form-input type="text" id="city-field" v-model="profile.city" placeholder="Moscow"/>
                            </b-form-group>

                            <b-form-group
                                    horizontal
                                    label="Country"
                                    label-for="country-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <b-form-input type="text" id="country-field" v-model="profile.country" placeholder="Russia"/>
                            </b-form-group>

                            <b-form-group
                                    horizontal
                                    label-for="primaryPhone-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <div slot="label">
                                    Primary Phone
                                    <span class="help-block">not required</span>
                                </div>
                                <b-form-input type="text" id="primaryPhone-field" v-model="profile.primaryPhone" placeholder="+1 555 555-1234"/>
                            </b-form-group>


                            <b-form-group
                                    horizontal
                                    label-for="length-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <div slot="label">
                                    Short Bio
                                    <span class="help-block">Describe yourself in one line !</span>
                                </div>

                                <textarea-autosize
                                        v-model="profile.shortBio"
                                        placeholder="" :rows="1"
                                        class="form-control"
                                        id="new-event"
                                        style="min-height:50px"
                                />
                            </b-form-group>
                            <b-form-group
                                    horizontal
                                    label="Bio"
                                    label-for="length-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <div slot="label">
                                    Bio
                                    <span class="help-block">Describe yourself, your passions, motivations, and future trips</span>
                                </div>

                                <textarea-autosize
                                        v-model="profile.bio"
                                        placeholder="" :rows="3"
                                        class="form-control"
                                        style="min-height:50px"
                                />
                            </b-form-group>
                            <b-form-group
                                    horizontal
                                    class="form-action"
                                    label-for="transparent-field"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <b-button variant="primary" type="submit" class="mr-xs">Save Changes</b-button>
                                <b-button variant="inverse">Cancel</b-button>
                            </b-form-group>
                        </b-form>
                    </b-form-group>
                </Widget>
            </b-col>

            <b-col lg="6" xs="6">
                <Widget customHeader>
                    <b-form-group>
                        <b-form @submit.prevent="saveEmail">


                            <legend><strong>Connect</strong> social accounts</legend>

                            <p v-if="allAccountsConnected">All social account connected</p>

                            <b-button variant="danger" block @click="linkWithGoogle" v-if="!isAccountLinked('google.com')">
                                <i class="fa fa-google"/>&nbsp;&nbsp;Connect Google account
                            </b-button>

                            <b-button variant="primary" block @click="linkWithFacebook" v-if="!isAccountLinked('facebook.com')">
                                <i class="fa fa-facebook"/>&nbsp;&nbsp;Connect with Facebook
                            </b-button>

                        </b-form>
                    </b-form-group>
                </Widget>
            </b-col>


            <b-col lg="6" xs="6">
                <Widget customHeader>
                    <b-form-group>
                        <b-form @submit.prevent="saveEmail">


                            <legend><strong>Update</strong> Email</legend>

                            <b-form-group
                                    horizontal
                                    label-for="disabled-field"
                                    label-class="text-md-right"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <div slot="label">
                                    Email
                                    <span class="help-block">we keep this private</span>
                                </div>
                                <b-form-input type="text" v-model="email"/>

                            </b-form-group>

                            <b-form-group
                                    horizontal
                                    class="form-action"
                                    label-for="transparent-field"
                                    :label-cols="4"
                                    breakpoint="md"
                            >
                                <b-button variant="primary" type="submit" class="mr-xs">Upodate Email</b-button>
                            </b-form-group>

                        </b-form>
                    </b-form-group>
                </Widget>
            </b-col>



        </b-row>
    </div>
</template>


<script>
  import Widget from '@/components/Widget/Widget'

  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')
  import UIHelpersMixins from '@/mixims/UIHelpersMixins'

  import Vue from 'vue'
  import Moment from 'moment'
  import VueTimeago from 'vue-timeago'
  import Likes from '@/components/Likes/Likes'
  import Post from '@/components/Posts/Post'
  import TextPostType from '@/components/Posts/Types/TextPostType'
  import MediaPostType from '@/components/Posts/Types/MediaPostType'
  import firebase from 'firebase'

  export default {
    name:       'Profile',
    components: {
      Post,
      MediaPostType,
      TextPostType,
      Widget,
      Likes,
    },
    props:      [
      'selectedUserId'
    ], mixins:
                [
                  UIHelpersMixins,
                ],
    data ()
    {
      return {
        email:   '',
        profile: {
          fullName:     '',
          jobTitle:     '',
          primaryPhone: '',
          primaryEmail: '',
          city:         '',
          country:      '',
          shortBio:     '',
          bio:          '',
        },
      }
    },
    mounted ()
    {
      var that = this

      this.$watch('$refs.userFollow.count', function (newValue, oldValue) {
        that.followersCnt = newValue + 1
      })

      that.$store.dispatch('userProfiles/retreiveProfile', this.currentUser.uid).then(function (userProfile) {

        that.profile = userProfile

        that.email = that.currentUser.email

      }).catch(function (err) {
        console.log(err)
      })

    },
    filters:    {},
    computed:   {

      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },
      isOwner ()
      {
        return this.currentUser.uid === this.$props.selectedUserId
      },
      isLocalDebug ()
      {
        return window.location.hostname === 'localhost'
      },

      allAccountsConnected ()
      {
        return this.isAccountLinked('google.com')
          && this.isAccountLinked('facebook.com')
      }
    },
    methods:    {
      saveProfile ()
      {
        this.$store.commit('userProfiles/updateProfile', this.profile)

        this.notifyVue('success', ' Profile Saved!')

        this.$router.push('/users/' + this.currentUser.uid)
      },

      saveEmail ()
      {
        var that = this

        this.currentUser.updateEmail(this.email).then(function (ee) {
          that.notifyVue('success', ' Email Saved!')

        }).catch(function (err) {

          that.notifyVue('danger', err.message)

          console.error(err)
        })

      },

      isAccountLinked (providerName)
      {
        var found = false
        this.currentUser.providerData.forEach(function (provider) {
          if (providerName === provider.providerId)
          {
            found = true
          }

        })
        return found

      },
      linkWithFacebook ()
      {
        var provider = new firebase.auth.FacebookAuthProvider()
        provider.addScope('email')

        fb.auth.currentUser.linkWithPopup(provider).then(function (result) {
          // Accounts successfully linked.
          var credential = result.credential
          var user       = result.user
          // ...
        }).catch(function (error) {
          // Handle Errors here.
          // ...
        })

      },
      linkWithGoogle ()
      {
        var provider = new firebase.auth.GoogleAuthProvider()
        provider.addScope('email')

        fb.auth.currentUser.linkWithPopup(provider).then(function (result) {
          // Accounts successfully linked.
          var credential = result.credential
          var user       = result.user
          // ...
        }).catch(function (error) {
          // Handle Errors here.
          // ...
        })

      },

    },
    watch:      {},

  }

</script>

<style src="./Profile.scss" lang="scss" scoped/>

<style>


</style>